import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { CurrencyEnum } from '../../../../lib/enums/currency.enum';
import lang from '../../../../lib/language';
import { RootState } from '../../../../lib/store/index';
import { AvailableCashElement, GetAccountsAvailableCashResponse } from '../../../../lib/store/reporting/types';
import { formatNumber } from '../../../../lib/util/DataHelpers';
import { CurrenciesSwitch } from '../../../../lib/util/types';

import IconCheck from '../../../../assets/img/wallet/icon-check.svg';
import IconEUR from '../../../../assets/img/wallet/icon-eu-flag.svg';
import IconTotal from '../../../../assets/img/wallet/icon-total-cash.svg';
import IconUS from '../../../../assets/img/wallet/icon-us-flag.svg';
import { ClickableDiv } from '../../../../components/index';

import styles from './CurrencyOptions.module.scss';

type Props = {
    activeCurrency: CurrenciesSwitch;
    handleClose: () => void;
    chooseCurrency: (value: CurrenciesSwitch) => void;
}

const CurrencyOptions = ({ activeCurrency, handleClose, chooseCurrency }: Props) => {
  const availableCash = useSelector<RootState, AvailableCashElement[]>(
    (state: RootState) => state.payment.availableCashInfo.availableCash[0].availableCashMultiCurrency,

  );

  const totalCash = useSelector<RootState, number>((state: RootState) => state.payment.calculatedCash);
  const activeRowTotalValue = activeCurrency === 'ALL';

  const onCurrencySwitch = (val: CurrenciesSwitch) => {
    chooseCurrency(val);
    handleClose();
  };

  const renderPopupBody = () => availableCash.map((el: AvailableCashElement) => {
    const activeRow = el.currency === activeCurrency;

    return (
      <ClickableDiv
        className={classNames(styles.rowPopup, { [styles.activeCurrency]: activeRow })}
        onClick={() => onCurrencySwitch(el.currency as CurrenciesSwitch)}
      >
        <div>
          <img src={el.currency === CurrencyEnum.USD ? IconUS : IconEUR} alt="county flag" />
          <span>{el.currency}</span>
          <span>{formatNumber(el.availableCash)}</span>
        </div>
        {activeRow && <img src={IconCheck} alt="check icon" />}
      </ClickableDiv>
    );
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <ClickableDiv
          className={classNames(styles.totalValue, styles.rowPopup,
            { [styles.activeCurrency]: activeRowTotalValue })}
          onClick={() => onCurrencySwitch('ALL')}
        >
          <div>
            <img src={IconTotal} alt="total value icon" />
            <span>{lang.fundScreenTotalValue(CurrencyEnum.USD, formatNumber(totalCash))}</span>
          </div>
          {activeRowTotalValue && <img src={IconCheck} alt="check icon" />}
        </ClickableDiv>
        {renderPopupBody()}
      </div>
    </div>
  );
};

export default CurrencyOptions;
